import { render } from "./ATabs.vue?vue&type=template&id=62a1dc9e"
import script from "./ATabs.vue?vue&type=script&lang=js"
export * from "./ATabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__